



















































































































































































































































































































































import PublishModal from "@/components/common/ModalPublishProduct.vue";
import { itemsShowOnCard } from "@/constants/product";
import ErrorService from "@/services/erroService";
import UserInterface from "@/types/app/IUser";
import Product from "@/types/app/products";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import Endpoint from "@/utils/endpoint";
import formatDate, { formatDateWithTime } from "@/utils/formatDate";
import formatMoney from "@/utils/formatMoney";
import { getProduct } from "@/utils/getProduct";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { VueEditor } from "vue2-editor";
import Notification, {
  webAppEmailInitialValue,
  notificationInitialValue,
  WebAppEmail,
} from "@/types/app/notifications";
import CommunicationEmailNotificationUser from "@/components/headers/communication-email-notification-users";
import Header from "@/types/app/header";
import applyCondition from "@/utils/applyCondition";
import BaseComponent from "@/utils/baseComponent";
import Customer from "@/types/customer/Customer";
import { AxiosInstance } from "axios";
import { getNotificationById } from "@/utils/getNotifications";
import AccountInterface from "@/types/app/accounts";
import CustomerService from "@/services/customerService";
import NotificationService from "@/services/notificationService";
import AccountService from "@/services/accountService";

const namespace = "communication";

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

@Component({
  data: () => ({
    required: (v: any) => !!v || "This field is required",
  }),
  components: { PublishModal, VueEditor },
  methods: {
    formatMoney,
    formatDate,
    formatDateWithTime,
  },
})
export default class NotificationEmailInformation extends BaseComponent {
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  emailNotification: Notification = notificationInitialValue;
  accounts: AccountInterface[] = [];

  accountService = new AccountService(this.$http);
  headers: Header[] = CommunicationEmailNotificationUser.header;
  customerService = new CustomerService(this.$http);
  notificationService = new NotificationService(this.$http)
  fullNameFilter = "";
  emailFilter = "";
  emailUserEdit: WebAppEmail = webAppEmailInitialValue;
  loadingNotifications = false;
  loadingEditEmailUser = false;
  selectedNotificationCustomers: any[] = [];
  filteredCustomers: VuetifySelectItems[] = [];
  selectedCustomers: any[] = [];
  dialogEditCopy = false;
  private endpoint = new Endpoint();
  loading = false;
  tab = "emailInformation";
  formType = "view";
  customersNotification: any[] = [];
  customToolbar = [
    [{ font: [] }],
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
    [{ header: 1 }, { header: 2 }],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["clean"],
    ["code-block"]
  ];
  showNewClient = false;

  get filteredNotificationCustomers() {
    try {
      const conditions: any[] = [];
      if (this.emailFilter) {
        conditions.push((item: WebAppEmail) =>
          item.email.toLowerCase().includes(this.emailFilter.toLowerCase())
        );
      }

      if (this.fullNameFilter) {
        conditions.push((item: WebAppEmail) =>
          item.fullName.toLowerCase().includes(this.fullNameFilter.toLowerCase())
        );
      }

      return applyCondition<WebAppEmail>(this.emailNotification.webAppEmails, conditions);
    }
    catch (error) {
      console.log('filter erro', error);
    }
    return this.emailNotification.webAppEmails;
  }

  get hasSelectedNotifications() {
    return this.selectedNotificationCustomers.length > 0;
  }

  get notificationId(): string {
    return this.$route.params.notificationId
  }

  async saveEmailInfo() {
    this.loadingNotifications = true;
    const result = await this.notificationService.saveInfo(this.notificationId,
      this.emailNotification.title,
      this.emailNotification.description,
      this.emailNotification.body.replace("<p><br></p>", ""));
    if (!result.hasErrors) {
      this.showSuccess('Save email information with success!!!')
      this.editEmailInfo('view');
    }
    else this.showError(result.messageErroDefault);
    this.loadingNotifications = false;
  }

  showEditEmailUser(item: WebAppEmail) {
    this.emailUserEdit = Object.assign({}, item);
    this.dialogEditCopy = true;
  }

  closeEditEmailModal() {
    this.emailUserEdit = Object.assign({}, webAppEmailInitialValue)
    this.dialogEditCopy = false;
  }

  async saveEditEmailModal() {
    if (this.loadingEditEmailUser === true) {
      return;
    }
    this.loadingEditEmailUser = true;
    const result = await this.notificationService.saveEmailUserInfo(this.notificationId,
      this.emailUserEdit.id,
      this.emailUserEdit.copyEmail);
    if (!result.hasErrors) {
      this.showSuccess('Save email information with success!!!')
      this.closeEditEmailModal();
      await this.handleNotifications();
      this.dialogEditCopy = false;
    }
    else this.showError(result.messageErroDefault);
    this.loadingEditEmailUser = false;

  }

  editEmailInfo(action: string) {
    this.formType = action;
  }


  get isView(): boolean {
    return this.formType == "view";
  }

  get isEdit(): boolean {
    return this.formType == "edit";
  }


  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(url);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) => {
      if (a.fundSiteName < b.fundSiteName) {
        return -1;
      }
      if (b.fundSiteName < a.fundSiteName) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
    }));

    return itemsForVuetifySelect;
  }

  closeModalResend() {
    this.showNewClient = false;
    this.selectedCustomers = [];
  }

  getUrlTransform(url: string): string {
    url = url.replace("{0}", "#ClientId#");
    if (this.emailNotification.requestNotificationData?.fundName)
      url = url.replace(
        this.emailNotification.requestNotificationData?.dataId,
        this.emailNotification.requestNotificationData?.fundName
      );
    if (this.emailNotification.requestNotificationData?.productName)
      url = url.replace(
        this.emailNotification.requestNotificationData?.dataId,
        this.emailNotification.requestNotificationData?.productName
      );
    if (!url) return this.emailNotification.requestNotificationData.pageRequest;

    return url;
  }

  async resendEmailNotification() {
    if (this.loadingNotifications)
      return;
    this.loadingNotifications = true;
    const url = `${this.endpoint.notifications}/resend-email`;

    await this.$http
      .post(url, {
        usersId: this.selectedNotificationCustomers.map((x) => x.userId),
        eventId: this.emailNotification.id,
      })
      .then((res: any) => {
        this.showSuccess("Send email(s) with success!");
      })
      .catch((error) => {
        ErrorService.onError({
          status: -1,
          message: "Notifications:ReSendEmailNotification",
          error,
        });
      })
      .finally(async () => {
        this.loadingNotifications = false;
        await this.handleNotifications();
      });
  }

  async mounted() {
    await this.handleNotifications();
  }

  async handleNotifications() {
    this.loadingNotifications = true;
    this.loading = true;
    const notificationsResponse = await getNotificationById(
      this.endpoint.notifications,
      this.notificationId,
      this.$http
    );
    //notificationsResponse.body = notificationsResponse.body;
    console.log(notificationsResponse.body)
    this.emailNotification = notificationsResponse;
    this.loadingNotifications = false;
    this.loading = false;


  }

  async addNewCustomers() {
    if (this.loadingNotifications)
      return;
    this.loadingNotifications = true;
    const url = `${this.endpoint.notifications}/addusers-email`;
    if (this.selectedCustomers.length > 0) {
      
      const usersId = this.selectedCustomers.filter(i => i.group == 'Clients' || i.group == 'Managers').map((item) => item.value);
      const investorIds = this.selectedCustomers.filter(i => i.group != 'Clients' && i.group != 'Managers').map((item) => item.value);

      await this.$http
        .post(url, {
          usersId,
          investorIds,
          eventId: this.emailNotification.id,
          notSendEmail: true,
        })
        .then((res: any) => {
          this.showSuccess("Add customers to email with success!");
          this.selectedCustomers = [];
          this.showNewClient = false;
        })
        .catch((error) => {
          ErrorService.onError({
            status: -1,
            message: "Notifications:AddCustomersEmailNotification",
            error,
          });
        })
        .finally(async () => {
          this.loadingNotifications = false;
          await this.handleNotifications();
        });
    }
  }

  get likesAllCustomer() {
    return this.selectedCustomers.length === this.filteredCustomers.length;
  }

  get likesSomeCustomers() {
    return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
  }

  toggleSelectAll() {
    this.$nextTick(() => {
      if (this.likesAllCustomer) {
        this.selectedCustomers = [];
      } else {
        this.selectedCustomers = this.filteredCustomers.map((x) => x.value);
      }
    });
  }
  get icon() {
    if (this.likesAllCustomer) return "mdi-close-box";
    if (this.likesSomeCustomers) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  async getAccounts() {
    try {
      const [newAccounts] = await Promise.all([this.accountService.getAccounts()])
      this.accounts = newAccounts;
    } catch (error) {
      ErrorService.onError(error);
    }
  }


  @Watch("showNewClient")
  async loadingInit() {
    if (this.showNewClient) {
      this.loadingNotifications = true;
      await Promise.all([this.getCustomersAll(), this.getAccounts()]);


      this.filteredCustomers = this.customersNotification;
      if (this.emailNotification.requestNotificationData?.productName?.length > 0)
        this.filteredCustomers = this.filteredCustomers.filter((x) => x.data.hasAccount);
      else if (this.emailNotification.requestNotificationData?.fundName?.length > 0)
        this.filteredCustomers = this.filteredCustomers.filter((item) =>
          this.accounts.some(
            (x) =>
              x.userId == item.value &&
              x.fundId == this.emailNotification.requestNotificationData?.dataId
          )
        );
      this.loadingNotifications = false;
    }
  }

  async checkCustomerHasAccount(customer: Customer) {
    return (
      this.accounts.some((x) => x.userId === customer.id) ||
      (customer.scheduleIndexResponse && customer.scheduleIndexResponse.status === "Done")
    );
  }


  async getCustomersAll(): Promise<void> {

    const customersAccount = await this.customerService.getSelectAccountCustomers();

    this.customersNotification.push({ header: 'Clients' });
    customersAccount.filter(x => x.group == 'Clients').forEach(element => {
      this.customersNotification.push(element);
    });
    this.customersNotification.push({ divider: true });

    const groups = customersAccount.filter(x => x.group != 'Clients').map(item => item.group)
      .filter((value, index, self) => self.indexOf(value) === index)

    groups.forEach(group => {
      this.customersNotification.push({ header: group });
      customersAccount.filter(x => x.group == group).forEach(customer => {
        this.customersNotification.push(customer);
      })
      this.customersNotification.push({ divider: true });
    });
    this.filteredCustomers = this.customersNotification;
  }

  downloadReport() {
    const { webAppEmails, ...rest } = this.emailNotification;
    const emailInformation = {
      title: rest.title,
      subject: rest.description,
      body: rest.body,
      authorName: rest.authorName,
      usersId: rest.usersId,
      urlRequest: decodeURIComponent(this.getUrlTransform(rest.url)),
    };

    const subItems = webAppEmails.map((x) => {
      return {
        fullName: x.fullName,
        email: x.email,
        link: x.link,
        dtSendEmail: formatDateWithTime(x.dtSendEmail),
        status: x.status,
        opensCount: x.opensCount ?? 0,
        clicksCount: x.clicksCount ?? 0,
        copyEmail: x.copyEmail,
      };
    });
    this.exportCSVFileV2(
      [emailInformation],
      subItems,
      `NotificationEmail-export`,
      "Email Report Info"
    );
  }
}
